import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=277b6128&scoped=true"
import script from "./mark.vue?vue&type=script&lang=ts"
export * from "./mark.vue?vue&type=script&lang=ts"
import style0 from "./mark.vue?vue&type=style&index=0&id=277b6128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b6128",
  null
  
)

export default component.exports